"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const theme_1 = require("../../styles/theme");
const TrashIconWeb = () => {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "7", height: "9", viewBox: "0 0 7 9", fill: "none" },
        react_1.default.createElement("path", { d: "M0.5 8C0.5 8.55 0.95 9 1.5 9H5.5C6.05 9 6.5 8.55 6.5 8V2H0.5V8ZM7 0.5H5.25L4.75 0H2.25L1.75 0.5H0V1.5H7V0.5Z", fill: "#FF1616" })));
};
const TrashIcon = (props) => {
    return (react_1.default.createElement(core_1.SvgIcon, Object.assign({ viewBox: "0 0 48 48" }, props),
        react_1.default.createElement("path", { fill: `${theme_1.colors.periWinkle}`, d: "M11,13v25c0,2.209,1.791,4,4,4h16c2.209,0,4-1.791,4-4V13H11z" }),
        react_1.default.createElement("path", { fill: `${theme_1.colors.blueGray}`, d: "M22 15H24V38H22zM28 15H30V38H28zM16 15H18V38H16z" }),
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { fill: `${theme_1.colors.indeigo}`, d: "M11 10H35V14H11z" }),
            react_1.default.createElement("path", { fill: `${theme_1.colors.indeigo}`, d: "M9 13H37V17H9zM19 12V8h8v4h2V8c0-1.104-.896-2-2-2h-8c-1.104 0-2 .896-2 2v4H19z" }))));
};
const getSize = (size) => ({ height: `${size}px`, width: `${size}px`, minHeight: `${size}px` });
const TGPreviewFieldWeb = props => {
    const { files, thumbnailSize, onDelete, onModal, translateFunction = text => text } = props, moreProps = __rest(props, ["files", "thumbnailSize", "onDelete", "onModal", "translateFunction"]);
    //sizing of elements based on the thumbnail size
    // const buttonSize = Math.round(thumbnailSize / 2.8);
    const iconSize = Math.round(thumbnailSize / 3.5);
    // const downloadBtnSize = Math.round(thumbnailSize / 10);
    const gap = Math.round(thumbnailSize / 14); //gap between thumbnails
    const previewSectionStyles = usePreviewSectionStyles();
    return (react_1.default.createElement(core_1.Box, { className: previewSectionStyles.wrapper }, files.map((file, index) => {
        const { id, url } = file;
        return (react_1.default.createElement("div", { style: Object.assign(Object.assign({}, getSize(thumbnailSize)), { margin: gap }), key: index, className: previewSectionStyles.previewImg },
            react_1.default.createElement("img", { src: url, alt: file.name }),
            react_1.default.createElement("div", { size: "small", className: previewSectionStyles.rightTopBtn, onClick: () => {
                    onDelete(id);
                } }, onModal ? (react_1.default.createElement("div", { className: previewSectionStyles.TrashContainer },
                react_1.default.createElement(TrashIconWeb, null))) : (react_1.default.createElement(TrashIcon, { style: { fontSize: iconSize } }))),
            onModal && (react_1.default.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", download: true },
                react_1.default.createElement(core_1.Button, { variant: "contained", size: "small", className: previewSectionStyles.bottomCenterBtn }, translateFunction('Download'))))));
    })));
};
const usePreviewSectionStyles = (0, core_1.makeStyles)((theme) => (0, core_1.createStyles)({
    wrapper: {
        display: 'grid',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 10,
        gap: 3,
        gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
    },
    previewImg: {
        position: 'relative',
        '& img': {
            width: '100%',
            height: '100%',
            borderRadius: 5,
        },
    },
    TrashIcon: {
        height: 13,
        width: 10,
    },
    TrashContainer: {
        height: 17,
        width: 17,
        background: theme_1.colors.white,
        boxShadow: `0px 2px 4px ${theme_1.colors.black25}`,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    rightTopBtn: {
        position: 'absolute',
        top: '-9%',
        right: '-9%',
        background: 'transparent',
        '&:hover': {
            background: 'none',
        },
    },
    bottomCenterBtn: {
        position: 'absolute',
        bottom: 6,
        left: '50%',
        transform: 'translate(-50%, 0%)',
        padding: '5px 7px',
        textTransform: 'capitalize',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: '100%',
        background: theme_1.colors.greyOfWhite,
        borderRadius: 3,
        boxShadow: 'none',
        color: theme_1.colors.black0,
    },
}));
exports.default = TGPreviewFieldWeb;
//# sourceMappingURL=TGPreviewFieldWeb.js.map